<!-- Order details -->
<div fxLayout="column" fxLayoutAlign="center center" fxFlexFill *ngIf="order && !loader">

  <div fxLayout="column" fxLayoutGap="30px" style="width: 444px;" [ngStyle.xs]="{'width': '90%'}">

    <!-- Header avec actions -->
    <div class="color-50 py-2 px-4">
      <div class="flex flex-row items-center">
        <div class="text-lg">{{order.reference}}</div>
        <span class="flex-1"></span>

        <!-- Bouton impression -->
        <button mat-icon-button color="primary" matTooltip="{{'successOrder.print'|translate}}" (click)="print()">
          <mat-icon>print</mat-icon>
        </button>
      </div>
    </div>

    <!-- Contenu scrollable -->
    <div class="flex-1 overflow-y-auto">

      <!-- Section succès avec barcode -->
      <div class="flex flex-col justify-center text-center">

        <!-- Icône succès -->
        <div fxLayout="column" class="text-center" fxLayoutGap="10px">

          <div>
            <i class="great-ico fa fa-check-circle" style="font-size: 5em;"></i>
          </div>

          <div class="text-lg mb-2">
            <span>{{"successOrder.order_check"|translate}}</span>
          </div>

          <!-- <div class="text-lg mb-2">
            <span>{{"order.reference"|translate}}</span>
            <span> {{order.reference}}</span>
          </div> -->

          <!-- Barcode -->
          <div *ngIf="barCodeValue" class="flex justify-center text-center">
            <app-newbarcode #barcode [value]="barCodeValue" [width]="1" [height]="80" [displayValue]="true"
              [fontSize]="16">
            </app-newbarcode>
          </div>

          <!-- Date de saisie -->
          <div class="text">
            <span>{{"successOrder.orderdate"|translate}}</span>
            <span>&nbsp;</span>
            <span>{{order.date_creation | dateFilter: 'LL'}}</span>
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Section Point de vente et méthode -->
        <div class="p-4 flex flex-col justify-center text-center">
          <div class="text-lg font-bold">{{order.point_of_sale.denomination}}</div>
          <div class="text-lg">{{order.sale_method?.name | uppercase}}</div>
          <div class="text-lg" *ngIf="order.date_execution">
            {{order.date_execution | dateFilter: 'LL'}}
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Section détails de paiement -->
        <div class="p-4" *ngIf="order && order.sale_method && !order.sale_method.ENABLE_DEVICE_CHECK">

          <div class="flex justify-between items-center mb-2">
            <span class="mat-subheading-1">{{"successOrder.modePayment"|translate}}</span>
            <div>
              <!-- Texte pour carte/comptoir/cagnotte -->
              <span class="mat-subheading-1 boldest" *ngIf="typeOfPayment === 'card'">
                {{'successOrderComponent.card'|translate}}
              </span>
              <span class="mat-subheading-1 boldest" *ngIf="typeOfPayment === 'counter'">
                {{'successOrderComponent.counter'|translate}}
              </span>
              <span class="mat-subheading-1 boldest" *ngIf="typeOfPayment === 'cagnotte'">
                {{'successOrderComponent.jackpot'|translate}}
              </span>

              <!-- Images pour autres paiements -->
              <img src="assets/img/refonte-logo/PAIEMENT-EN-LIGNE.png"
                *ngIf="typeOfPayment === 'mypos' || typeOfPayment === 'yavin'" class="h-10">
              <img src="assets/img/refonte-logo/payment.png" *ngIf="typeOfPayment === 'borne'" class="h-10">
              <img src="assets/img/paypal-logo/paypal_logo.png" *ngIf="typeOfPayment === 'paypal'" class="h-10">
              <img src="assets/img/bancontact/bancontact_logo.png" *ngIf="typeOfPayment === 'bancontact'" class="h-10">
              <img src="assets/img/refonte-logo/PAYZEN.png" *ngIf="typeOfPayment === 'payzen'" class="h-10">
              <img src="assets/img/refonte-logo/STRIPE.png" *ngIf="typeOfPayment === 'stripe'" class="h-10">
            </div>
          </div>

          <!-- Total -->
          <div class="flex justify-between items-center mb-2"
            *ngIf="order.date_execution && typeOfPayment !== 'counter'">
            <span class="mat-subheading-1">{{'successOrderComponent.Total'|translate}}</span>
            <span class="mat-subheading-1 boldest">{{order.total_str}}</span>
          </div>

          <!-- Cagnotte utilisée -->
          <div *ngIf="order && order.order_payments.length > 0">
            <div *ngFor="let item of order.order_payments">
              <div class="flex justify-end items-center gap-2 text-sm"
                *ngIf="item.id_payment_mean === -15 && item.archive === 0 && item.captured">
                <span>{{'successOrderComponent.jackpotUsed'|translate}}</span>
                <span>{{item.total_str}}</span>
              </div>
            </div>
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Section panier (liste des produits) -->
        <div class="p-4" *ngIf="basket && basket.length > 0">
          <div class="text-lg font-bold mb-3">{{"successOrderComponent.basket"|translate}}</div>

          <div *ngFor="let product of basket" class="flex justify-between items-start mb-3 pb-3 border-b">
            <div class="flex-1">
              <div class="font-medium">{{product.quantity}}&nbsp;&nbsp;x&nbsp;&nbsp;{{product.name}}</div>
              <div class="text-sm text-gray-600" *ngIf="product.options && product.options.length > 0">
                <div *ngFor="let option of product.options">
                  + {{option.name}}
                </div>
              </div>
            </div>
            <div class="font-medium">{{product.total_str}}</div>
          </div>
        </div>

        <!-- Statut de la commande -->
        <div>
          <div class="p-4 flex flex-col justify-center text-center">
            <div class="text-lg font-bold mb-3">{{"successOrderComponent.status"|translate}}&nbsp;:</div>
            <div class="text-lg" *ngIf="currentOrderLevelName">
              <span [style.color]="currentOrderLevelColor">
                {{ currentOrderLevelName }}
              </span>
            </div>
          </div>
        </div>

      </div>

      <!-- Footer avec boutons d'action -->
      <div class="p-4 border-t">
        <div class="flex gap-2">

          <!-- Bouton compte ou nouvelle commande -->
          <button mat-raised-button color="primary" *ngIf="!modeBorne" (click)="goHomeAccount()" angulartics2On="click"
            angularticsAction="redirectAccount" angularticsCategory="endOrder" class="flex-1">
            <mat-icon>account_circle</mat-icon>
            <span class="ml-2" fxHide.xs>{{"goSpaceFulle"|translate}}</span>
          </button>

          <button mat-raised-button color="primary" *ngIf="modeBorne" (click)="goProductPage()" angulartics2On="click"
            angularticsAction="redirectNewOrder" angularticsCategory="endOrder" class="flex-1">
            <mat-icon>shopping_cart</mat-icon>
            <span class="ml-2" fxHide.xs>{{"successOrder.newOrder"|translate}}</span>
          </button>
        </div>

        <!-- Timer de redirection (mode borne) -->
        <div *ngIf="this.tools.getStor('devicePaybridge')" class="mt-3 text-center font-bold text-lg"
          [innerHtml]="'cancel_order_di.redirectionSuccess' | translate:{'timeSec': timeSec}">
        </div>
      </div>

    </div>
  </div>
</div>

<!-- No Order found -->
<div *ngIf="!order && !loader" class="flex flex-col items-center justify-center h-full p-8">
  <i class="material-icons warn-ico" style="font-size: 4em;">error</i>
  <span class="mat-subheading-1 mt-4">{{"successOrder.noOrder"|translate}}</span>

  <div class="mt-8">
    <button mat-raised-button color="primary" *ngIf="modeBorne" (click)="goProductPage()" angulartics2On="click"
      angularticsAction="redirectNewOrder" angularticsCategory="endOrder">
      <mat-icon>shopping_cart</mat-icon>
      <span class="ml-2">{{"successOrder.newOrder"|translate}}</span>
    </button>

    <button mat-raised-button color="primary" *ngIf="!modeBorne" (click)="goHomeAccount()" angulartics2On="click"
      angularticsAction="redirectAccount" angularticsCategory="endOrder">
      <mat-icon>account_circle</mat-icon>
      <span class="ml-2" fxHide.xs>{{"goSpaceFulle"|translate}}</span>
    </button>
  </div>
</div>

<!-- Loader -->
<app-fulle-page-loader [loader]="loader"></app-fulle-page-loader>